import React from 'react';
import Customer from './customer';

// Reuse the directory's payment workflow and permissions, with a compact view.
export default function CustomerPayments() {
    return <Customer paymentsOnly />;
}
